<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Preferências</h1>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" placeholder="Buscar..." @reset="reset" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nome</th>
          <th class="px-6 pt-6 pb-4">Descrição</th>
          <th class="px-6 pt-6 pb-4">Favorito</th>
          <th class="px-6 pt-6 pb-4">Criado Em</th>
          <th class="px-6 pt-6 pb-4">#</th>
        </tr>
        <tr v-for="preference in preferences.data" :key="preference.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('preferences.edit', preference.id)">
              {{ preference.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('preferences.edit', preference.id)">
              {{ preference.description }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('preferences.edit', preference.id)" tabindex="-1">
              <active-badge :active="preference.favorite" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('preferences.edit', preference.id)" tabindex="-1">
              {{ customFormatter(preference.created_at) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <button class="px-6 py-4 flex items-center text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy(preference.id)">Deletar</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '../../Shared/TextInput'
import ActiveBadge from '@/Shared/ActiveBadge'
import moment from 'moment'

export default {
  metaInfo: { title: 'Preferências' },
  components: {
    TextInput,
    ActiveBadge,
  },
  layout: Layout,
  props: {
    filters: Object,
    preferences: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('preferences'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    destroy(id) {
      if (confirm('Deletar ?')) {
        this.$inertia.delete(this.route('preferences.destroy', id))
      }
    },
  },
}
</script>
